import ApplicationDetailsFeature from "../features/ApplicationDetails";

export default function ApplicationDetails() {
  return <ApplicationDetailsFeature />;
}
